import { useEffect, useState } from 'react';
import { StreamingPlayerWebClientConfigV2 } from '@heardis/stream-contracts';
import { fetchJSON } from '../utils/api';
import loggerService from '../utils/logger';
import { useConfigContext } from '../contexts/ConfigContext';
import { useSettingsContext } from '../contexts/SettingsContext';

function useConfig(): { configIsLoading: boolean; errorMessage: string | null } {
  const { setConfig } = useConfigContext();
  const { cache } = useSettingsContext();
  const [configIsLoading, setConfigIsLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const cacheIsDisabled = !cache;
    let previewQuery = '';

    if (cacheIsDisabled) {
      const randomPreviewId = Math.random().toString(36).slice(2);
      previewQuery = `?r=${randomPreviewId}`;
    }

    async function getConfig() {
      try {
        setErrorMessage(null);
        const config = await fetchJSON<StreamingPlayerWebClientConfigV2>(`custom/config.json${previewQuery}`);
        setConfig(config);
        setConfigIsLoading(false);
      } catch (error) {
        loggerService.error('fetchError =>', error);
        if (error instanceof Error) {
          setConfigIsLoading(false);
          setErrorMessage(error.message);
        }
      }
    }

    getConfig();
  }, []);

  return { configIsLoading, errorMessage };
}

export default useConfig;
